module.exports = __webpack_public_path__ + "img/dental4final.b76d2a02.jpeg";